<ul class="nav level-2" *ngIf="!selectedCharts.size">
  <li class="nav-item template-name">
    <span class="nav-label">
      <span>{{ dashboard?.name }}</span>
    </span>
  </li>
  <li class="nav-item">
    <a routerLink="../grid" class="nav-link" routerLinkActive="active">
      <i class="cc-icon cc-icon-grid"></i> Grid
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="../register" class="nav-link" routerLinkActive="active">
      <i class="cc-icon cc-icon-register"></i>
      <span>Register</span>
    </a>
  </li>
  <li class="nav-item ml-auto" *ngIf="charts.length && canAdd">
    <a class="nav-link nav-btn-success" (click)="addChart.emit()" ccSegmentCTA="Chart Add">
      <span i18n>Add chart</span>
    </a>
  </li>
</ul>

<ul class="nav level-2" *ngIf="selectedCharts.size">
  <li class="nav-item" *ngIf="canAdd">
    <a class="nav-link sm-items-center" (click)="deleteSelected.emit()"
      ><i class="cc-icon cc-icon-delete sm-mr-1 sm-text-default-red"></i>Delete</a
    >
  </li>
</ul>
